import useSound from 'use-sound';
import { useState } from "react";
export const useDownLinkSound = () => {
  const [isReady, setReady] = useState(false)

  const handleLoad = () => {
    setTimeout(()=> {
      // タイミングをズラさないとplayを呼び出してもuseSound側のsoundステートがnullになってしまう
      setReady(true);
    })
  }

  const [play] = useSound('sounds/downlink.mp3', {onload: handleLoad})

  return {
    play,
    isReady
  }
}
